import { render } from "./back.vue?vue&type=template&id=64d91216"
const script = {}
script.render = render

export default script